import * as Yup from "yup";

export const studentSatisfactionVideValidation = Yup.object().shape({
  videoUrl: Yup.string().required("وارد کردن آدرس ویدئو الزامی است"),
});
